import { faBell, faPlus, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import RequestModalAdd from "./RequestModalAdd";
import RequestList from "./RequestList";
import UserList from "./UserList";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import TabBar from "../../../components/ui/TabBar";
import InfoNoData from "../../../components/global/InfoNoData";
import { loadListOutRequest } from "../../../reducers/models/company/companyList";
import ErrorAdd from "../../../util/ErrorAdd";

function Index() {

  const dispatch = useDispatch()

  //TAB START
  const [tab, setTab] = useState([
    { id_tab: 1, name: "Пользователи", icon: faUser, showCount: false }
    , { id_tab: 2, name: "Заявки", icon: faBell, showCount: true, count: 0 }
  ]);
  const [tabSelected, setTabSelected] = useState(1);

  const stateUserList = useSelector((state) => state.userList);
  const stateCompanyList = useSelector((state) => state.companyList);

  //TAB END
  useEffect(() => {
    //Загружаем заявки
    if (stateCompanyList.listOutRequest === null) {
      axios.get('/api_main/company/requestOutList', { params: { ID_Service: process.env.REACT_APP_ID_SERVICE } })
        .then((res) => {
          if (res.data.Status === 1) {
            dispatch(loadListOutRequest({ data: res.data.Data }));
          }
        })
        .catch((err) => {
          ErrorAdd(err, window.location.href);
        });
    }
  }, []);

  useEffect(() => {
    //Загружаем заявки
    if (stateCompanyList.listOutRequest !== null) {
      //Обновляем счетчик
      setTab(tab.map(t => {
        if (t.id_tab === 2) {
          return { ...t, count: stateCompanyList.listOutRequest.length }
        }
        else {
          return t;
        }
      }))
    }
  }, [stateCompanyList.listOutRequest]);

  //TAB
  const [tabActiveShow, setTabActiveShow] = useState(true);
  const [tabRequestShow, setTabRequestShow] = useState(false);

  function tabCompanyHandleClick(e) {
    if (e.currentTarget.id === "tab_active") {
      setTabActiveShow(true);
      setTabRequestShow(false);
    }
    if (e.currentTarget.id === "tab_request") {
      setTabActiveShow(false);
      setTabRequestShow(true);
    }
  }

  //Модальные окна
  const [modalRequestAddShow, setModalRequestAddShow] = useState(false);


  function tabHandler(id_tab) {
    setTabSelected(id_tab);
  }

  //console.log('stateUserList', stateUserList)

  return (
    <div className='admin_content'>
      {modalRequestAddShow === true && (<RequestModalAdd show={modalRequestAddShow} onHide={() => setModalRequestAddShow(false)} />)}

      <div className="mb-20">
        <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} /*filterShow={filterShow}*/ /*setFilterShow={setFilterShow}*/ showAdd={true} setAddShow={setModalRequestAddShow} showFilter={false} />
      </div>
      {tab.map(tab => (
        <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
          <div className="mt-20">
            {
              <>
                {tabSelected === 1 && (
                  stateUserList.list.length === 0 ? <InfoNoData text="Нет пользователей" /> : <UserList data={stateUserList.list} />
                )}
                {tabSelected === 2 && (
                  stateCompanyList.listOutRequest !== null &&
                    stateCompanyList.listOutRequest.filter(a => a.ID_Status === 0).length === 0 ? <InfoNoData text="Нет заявок" /> : <RequestList data={stateCompanyList.listOutRequest.filter(a => a.ID_Status === 0)} />
                )}
              </>
            }
          </div>
        </div>
      ))
      }
    </div>
  );
}

export default Index;
